import {
  Button,
  Form,
  Select,
  Skeleton,
  Spin,
  Steps,
  Upload,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Aeps3MemberOnboard,
  getAllAeps3Masters,
  MemberProfile,
} from "../../../ApiServices/Apifun";
import Compressor from "compressorjs";
import {
  aadharPattern,
  dispatchtoast,
  emailPattern,
  fetchMemberProfile,
  filterOption,
  getLocalStorageItem,
  panPattern,
} from "../../../Utils";
import { setProfile, setselectedTab } from "../../../Store/B2bslice";
import CommonInput from "../../../Common/CommonInput";
import { IoCloudUploadOutline } from "react-icons/io5";
import { Images } from "../../../Controller";

const Aeps3MerchantOnboard = () => {
  const dispatch = useDispatch();
  const formref = useRef();
  const [form] = Form.useForm();
  const [states, setstates] = useState([]);
  const navigate = useNavigate();
  const [isRent, setIsRent] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const [showPendingScreen, setShowPendingScreen] = useState("");

  const [panImage, setPanImage] = useState([]);
  const [aadharImage, setAadharImage] = useState([]);
  const [shopImage, setShopImage] = useState([]);
  const [shopAddressProof, setShopAddressProof] = useState([]);
  const memberServices = useSelector((state) => state.B2B.memberServices);

  const [panImageBase, setPanImageBase] = useState("");
  const [aadharImageBase, setAadharImageBase] = useState("");
  const [shopImageBase, setShopImageBase] = useState("");
  const [shopAddressProofBase, setShopAddressProofBase] = useState("");

  const [imageDetail, setImageDetail] = useState({
    pan_image: [],
    aadhar_image: [],
    shop_image: [],
    shop_address_proof: [],
  });

  const handleImageChange = (file, from) => {
    try {
      new Compressor(file, {
        quality: 0.8,
        mimeType: "image/jpeg",

        success: (compressedResult) => {
          const reader = new FileReader();

          reader.onload = () => {
            let data = {
              uid: Date.now(),
              name: compressedResult.name,
              status: "done",
              originFileObj: compressedResult,
              thumbUrl: URL.createObjectURL(compressedResult),
            };

            if (from === "pan_image") {
              setPanImageBase(reader.result);
              setPanImage([data]);

              setImageDetail((prev) => ({
                ...prev,
                pan_image: [data],
              }));
            } else if (from === "aadhar_image") {
              setAadharImageBase(reader.result);
              setAadharImage([data]);

              setImageDetail((prev) => ({
                ...prev,
                aadhar_image: [data],
              }));
            } else if (from === "shop_image") {
              setShopImageBase(reader.result);
              setShopImage([data]);

              setImageDetail((prev) => ({
                ...prev,
                shop_image: [data],
              }));
            } else if (from === "shop_address_proof") {
              setShopAddressProofBase(reader.result);
              setShopAddressProof([data]);

              setImageDetail((prev) => ({
                ...prev,
                shop_address_proof: [data],
              }));
            }
          };

          reader.readAsDataURL(compressedResult);
        },
      });
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const props = {
    showUploadList: {
      showRemoveIcon: false,
    },
  };
  const handleFinish = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    console.log(val, "yhy");

    formdata.append("member_name", val.member_name ?? "" ?? "");
    formdata.append("company_name", val.company_name ?? "");
    formdata.append("address", val.address ?? "");
    formdata.append("area", val.area ?? "");
    formdata.append("member_city", val.member_city ?? "");
    formdata.append("member_district", val.member_district ?? "");
    formdata.append("pincode", val.pincode ?? "");
    formdata.append("mobile", val.mobile ?? "");

    formdata.append("shop_name", val.shop_name ?? "");
    formdata.append("shop_address", val.shop_address ?? "");
    formdata.append("shop_state", val.shop_state ?? "");
    formdata.append("shop_city", val.shop_city ?? "");
    formdata.append("shop_district", val.shop_district ?? "");
    formdata.append("shop_area", val.shop_area ?? "");
    formdata.append("shop_pin_code", val.shop_pin_code ?? "");

    formdata.append("pan_card", val.pan_card ?? "");
    formdata.append("email_id", val.email_id ?? "");
    formdata.append("aadhaar_number", val.aadhaar_number ?? "");

    formdata.append("pan_image", panImageBase);
    formdata.append("aadhar_image", aadharImageBase);
    formdata.append("shop_image", shopImageBase);
    formdata.append("shop_address_proof", shopAddressProofBase);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    formdata.append("shop_address", val.shop_address ?? "");

    formdata.append("shop_name", val.shop_name ?? "");

    Aeps3MemberOnboard(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          // navigate("/dashboard");
          MemberProfile()
            .then((response) => {
              if (response.status) {
                dispatch(setProfile(response.data.profile));
                setShowPendingScreen(response.data?.profile?.aeps3_status);
              } else {
                dispatchtoast("Unable to fetch profile detail", true);
              }
            })
            .catch((err) => console.log(err, "errr"));
        } else {
          dispatchtoast(res.message, true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  // const getMeberData = () => {
  //   Aeps3MemberData()
  //     .then((res) => {
  //       if (res.status) {
  //         const {
  //           aadhar_dob,
  //           aadhar_gender,
  //           aadhar_id_number,
  //           aadhar_name,
  //           member_id,
  //           mobile,
  //           pan_id_number,
  //         } = res.data;
  //         formref.current.setFieldsValue({
  //           aadhar_dob,
  //           aadhar_gender,
  //           aadhar_id_number,
  //           aadhar_name,
  //           member_id,
  //           mobile,
  //           pan_id_number,
  //         });
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };
  useEffect(() => {
    // getMeberData();

    getAllAeps3Masters()
      .then((res) =>
        setstates(
          res.data.state?.map((i, index) => {
            return {
              label: i.stateName,
              value: i.stateName,
              key: i.stateId,
            };
          }),
        ),
      )
      .catch((err) => console.log(err));
  }, [showPendingScreen]);
  useEffect(() => {
    dispatch(setselectedTab("1123.1"));
    if (memberServices.includes("207")) {
      if (profiledetail.aeps3_status == "0") {
        // return "/banking/aeps3-merchant-onboard";
        setShowPendingScreen("0");
      } else if (profiledetail.aeps3_status == "1") {
        return navigate("/aeps-3");
      } else if (profiledetail.aeps3_status == "2") {
        setShowPendingScreen("2");
      } else {
        console.log(profiledetail.aeps3_status, "status");
        setShowPendingScreen("3");
      }
    } else {
      navigate("/not-available");
    }
  }, [showPendingScreen]);
  return (
    <>
      {" "}
      {showPendingScreen == "3" ? (
        <div className="p-4 flex flex-col justify-center h-1/2 items-center text-center bg-white rounded-md">
          <img src={Images.pending} alt="pending" className="w-28" />
          <p className="mt-14 font-bold text-xl text-center">
            Your Onboarding is pending .
          </p>
          <p
            onClick={() => window.location.reload()}
            className="mt-10 font-semibold text-lg cursor-pointer text-white bg-primary p-2 rounded-lg text-center"
          >
            Refresh Page
          </p>
        </div>
      ) : showPendingScreen == "2" ? (
        <div className="p-4 flex flex-col justify-center h-1/2 items-center text-center bg-white rounded-md">
          <img src={Images.failed} alt="pending" className="w-28" />
          <p className="mt-14 font-bold text-xl text-center">
            Your Onboarding is failed.
          </p>

          <button
            onClick={() => setShowPendingScreen("0")}
            className="mt-5 font-bold text-sm bg-primary cursor-pointer text-white h-10 px-4 rounded-md text-center"
          >
            Do Again
          </button>
        </div>
      ) : (
        showPendingScreen == "0" && (
          <div className="bg-white p-4 rounded-md">
            <div className="p-4 bg-white rounded-md">
              <p className="font-bold text-2xl">Member Onboarding</p>
              <Form
                onFinish={(val) => handleFinish(val)}
                onFinishFailed={(err) => console.log(err)}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4 place-items-center">
                  <Form.Item
                    className="w-full"
                    name={`member_name`}
                    label={"Member Name"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Member Name!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Member Name"
                      name="member_name"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`company_name`}
                    label={"Company Name"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Company Name!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Company Name"
                      name="company_name
"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`address`}
                    label={"Address"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Address!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput placeholder="Enter Address" name="address" />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`area`}
                    label={"Area"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Area!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput placeholder="Enter Area" name="area" />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`aadhaar_number`}
                    label={"Aadhaar Number"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Aadhaar Number!",
                      },
                      {
                        pattern: aadharPattern,
                        message: "Enter Valid Aadhaar Number",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Aadhaar Number"
                      name="aadhaar_number"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`pan_card`}
                    label={"PAN Card"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter PAN Card Number!",
                      },
                      {
                        pattern: panPattern,
                        message: "Enter Valid PAN Card Number",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter PAN Card Number"
                      name="pan_card"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`member_city`}
                    label={"User City"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter User City!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter User City"
                      name="member_city"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`member_district`}
                    label={"User District"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter User District!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter User District"
                      name="member_district"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`pincode`}
                    label={"Pincode"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Pincode!",
                      },
                      {
                        pattern: /^[0-9]{6}$/,
                        message: "Enter Valid Pincode",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput placeholder="Enter Pincode" name="pincode" />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`mobile`}
                    label={"Mobile"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Mobile Number!",
                      },
                      {
                        pattern: /^[6-9]\d{9}$/,
                        message: "Enter Valid Mobile Number",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Mobile Number"
                      name="mobile"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`email_id`}
                    label={"Email"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Email!",
                      },
                      { pattern: emailPattern, message: "Enter Valid Email" },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput placeholder="Enter Email" name="email_id" />
                  </Form.Item>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4 place-items-center">
                  <p className="font-bold text-xl">Shop Details</p>
                  <Form.Item
                    className="w-full"
                    name={`shop_name`}
                    label={"Shop Name"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop Name!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Shop Name"
                      name="shop_name"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`shop_state`}
                    label={"Shop State"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop State!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select State"
                      showSearch
                      filterOption={filterOption}
                      className="w-full "
                      options={states}
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`shop_city`}
                    label={"Shop City"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop City!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Shop City"
                      name="shop_city"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`shop_district`}
                    label={"Shop District"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop District!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Shop District"
                      name="shop_district"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`shop_area`}
                    label={"Shop Area"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop Area!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Shop Area"
                      name="shop_area"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`shop_pin_code`}
                    label={"Shop Pin Code"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop Pin Code!",
                      },
                      {
                        pattern: /^[0-9]{6}$/,
                        message: "Enter Valid Shop Pin Code",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Shop Pin Code"
                      name="shop_pin_code"
                    />
                  </Form.Item>
                  <Form.Item
                    className="w-full"
                    name={`shop_address`}
                    label={"Shop Address"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Shop Address!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Shop Address"
                      name="shop_address"
                    />
                  </Form.Item>{" "}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2  gap-x-5 mt-4">
                  <Form.Item
                    name={`pan_image`}
                    className="font-semibold"
                    label={"Pan Image"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Upload Pan Image!",
                      },
                    ]}
                  >
                    <Upload
                      maxCount={1}
                      listType="picture"
                      fileList={imageDetail.pan_image}
                      customRequest={({ file }) =>
                        handleImageChange(file, "pan_image")
                      }
                      accept=".jpg,.jpeg,.png,.webp"
                      {...props}
                      defaultFileList={[]}
                    >
                      <div className="flex justify-center  items-center gap-4 bg-green-600 text-white  px-4 py-2 shadow shadow-gray-400 rounded-3xl ">
                        <IoCloudUploadOutline />
                        <p>Upload</p>
                      </div>
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    name={`aadhar_image`}
                    className="font-semibold"
                    label={"Aadhar Image"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Upload Aadhar Image!",
                      },
                    ]}
                  >
                    <Upload
                      maxCount={1}
                      listType="picture"
                      fileList={imageDetail.aadhar_image}
                      customRequest={({ file }) =>
                        handleImageChange(file, "aadhar_image")
                      }
                      accept=".jpg,.jpeg,.png,.webp"
                      {...props}
                      defaultFileList={[]}
                    >
                      <div className="flex justify-center  items-center gap-4 bg-green-600 text-white  px-4 py-2 shadow shadow-gray-400 rounded-3xl ">
                        <IoCloudUploadOutline />
                        <p>Upload</p>
                      </div>
                    </Upload>
                  </Form.Item>{" "}
                  <Form.Item
                    name={`shop_image`}
                    label={" Shop Image"}
                    className="font-semibold"
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Upload Shop Image!",
                      },
                    ]}
                  >
                    <Upload
                      maxCount={1}
                      listType="picture"
                      fileList={imageDetail.shop_image}
                      customRequest={({ file }) =>
                        handleImageChange(file, "shop_image")
                      }
                      accept=".jpg,.jpeg,.png,.webp"
                      {...props}
                      defaultFileList={[]}
                    >
                      <div className="flex justify-center  items-center gap-4 bg-green-600 text-white  px-4 py-2 shadow shadow-gray-400 rounded-3xl ">
                        <IoCloudUploadOutline />
                        <p>Upload</p>
                      </div>
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    name={`shop_address_proof`}
                    className="font-semibold"
                    label={"Shop Address Proof"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Upload Shop Address Proof!",
                      },
                    ]}
                  >
                    <Upload
                      maxCount={1}
                      listType="picture"
                      fileList={imageDetail.shop_address_proof}
                      customRequest={({ file }) =>
                        handleImageChange(file, "shop_address_proof")
                      }
                      accept=".jpg,.jpeg,.png,.webp"
                      {...props}
                      defaultFileList={[]}
                    >
                      <div className="flex justify-center  items-center gap-4 bg-green-600 text-white  px-4 py-2 shadow shadow-gray-400 rounded-3xl ">
                        <IoCloudUploadOutline />
                        <p>Upload</p>
                      </div>
                    </Upload>
                  </Form.Item>
                </div>
                <div className="flex mt-4 justify-end items-center">
                  <Form.Item>
                    <Button
                      loading={btnLoading}
                      htmlType="submit"
                      className="bg-primary outline-none border-none text-white"
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default Aeps3MerchantOnboard;
